export default {"src":"/_next/static/media/dark_mode.7ccaecd8.svg","height":308,"width":488,"blurWidth":0,"blurHeight":0};